/// <amd-module name="Test/TestResultsView/Actions/TestResultsViewActionHub" />
import { Action } from "VSS/Reflux/Action";
import { ITestResultTreeData } from "Test/common-util/Contracts/ViewContracts";

export class TestResultsViewActionHub {
    public openTestResultDetailsView = new Action<ITestResultViewDetails>();
    public onPivotChagnedInDetailsPane = new Action<string>();
    public onGridRowClicked = new Action<{testResultTreeData: ITestResultTreeData, mobileView: boolean}>();
}

export interface ITestResultViewDetails {
    runId: number;
    resultId: number;
    paneView: string;
    isFullscreen: boolean;
}

export enum DetailsPaneMode {
    Off,
    HalfScreen,
    FullScreen,
    MobileView
}